export default function (field) {
  return function (item) {
    if (!field || !item) {
      return null;
    }

    if (item[field.code] === undefined && !field.required) {
      return null;
    }

    if (field.required) {
      if (!(field.code in item)) {
        return "required";
      } else {
        const val = item[field.code];
        if (val === null || val === undefined) {
          return "required";
        }
      }
    }
    const val = +item[field.code];

    if (isNaN(val)) {
      return "Invalid number";
    }

    if (field.max !== null || field.max !== undefined) {
      if (val > field.max) {
        return "Over Maximum of " + field.max;
      }
    }
    if (field.min !== null || field.min !== undefined) {
      if (val < field.min) {
        return "Under Minimum of " + field.min;
      }
    }

    return null;
  };
}
